module.exports = __webpack_public_path__ + "img/4.bcb4a619.png";